<template lang="html">
  <div class="">

    <div class="select_question select_question-red container align-items-stretch">
      <div class="img container align-center">
        <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
      </div>
      <div class="flex-grow-1 bordered-box bordered-box-orange">
        <p>{{ question.question }}</p>
      </div>
    </div>

    <div class="select-question select-question__height container">

      <div class="select-question__left flex-grow-1 flex-basis-600">
        <div class="unit-challenge__video flex-grow-1 flex-basis-400 container align-center animation-top">
          <video ref="video" poster="@/assets/img/exercicies/words-attack/intro.png" class="unit-challenge__video--image"
            width="100%" height="auto" :src="exercise.video" @pause="playing = false; first = false; interrupted = true"
            @playing="playing = true; played = true" @timeupdate="timeUpdated($event.target.currentTime)" />
          <button class="video__button" @click="playVideo()" v-if="!playing && first">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="135" height="135"
              viewBox="0 0 431.26 431.26">
              <defs>
                <clipPath id="b">
                  <rect width="431.26" height="431.26" />
                </clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <circle cx="215.628" cy="215.628" r="215.628" transform="translate(0 0)" fill="#f3f3f3" opacity="0.31" />
                <g transform="translate(383.337 383.337) rotate(180)">
                  <g transform="translate(0 0)">
                    <path d="M162.729,325.458h0A162.728,162.728,0,0,1,0,162.729H0A162.728,162.728,0,0,1,162.729,0h0A162.728,162.728,0,0,1,325.458,162.729h0A162.728,162.728,0,0,1,162.729,325.458Z"
                      transform="translate(4.981 4.981)" fill="#fdd93b" />
                    <g transform="translate(4.981 4.981)">
                      <path d="M162.731,325.458A162.772,162.772,0,0,1,99.389,12.788,162.771,162.771,0,0,1,226.071,312.67,161.7,161.7,0,0,1,162.731,325.458Zm0-305.53A142.8,142.8,0,0,0,61.752,263.706,142.8,142.8,0,1,0,263.706,61.752,141.865,141.865,0,0,0,162.731,19.928Z"
                        transform="translate(0 0)" fill="#f5a800" />
                      <path d="M0,98.265,150.5,0V196.531Z" transform="translate(62.713 64.464)" fill="#f5a800" />
                    </g>
                    <path d="M112.914,147.453,0,73.726,112.914,0Z" transform="translate(91.992 93.984)" fill="#e2324e" />
                    <path d="M0,8.3,112.914,82.029V65.423L12.715,0Z" transform="translate(91.992 159.408)" fill="#a00b3f" />
                    <path d="M167.712,335.42A167.711,167.711,0,0,1,49.12,49.12,167.711,167.711,0,0,1,286.3,286.3,166.611,166.611,0,0,1,167.712,335.42Zm0-325.458c-86.983,0-157.75,70.766-157.75,157.75s70.766,157.746,157.75,157.746,157.746-70.765,157.746-157.746S254.693,9.962,167.712,9.962Z" />
                    <path d="M9.963,0H0A146.818,146.818,0,0,0,43.285,104.5a146.815,146.815,0,0,0,104.5,43.285v-9.963A136.92,136.92,0,0,1,50.33,97.455,136.922,136.922,0,0,1,9.963,0Z"
                      transform="translate(19.926 167.71)" />
                    <path d="M104.5,43.284A146.822,146.822,0,0,0,0,0V9.963A136.919,136.919,0,0,1,97.455,50.33a136.923,136.923,0,0,1,40.366,97.455h9.963A146.823,146.823,0,0,0,104.5,43.284Z"
                      transform="translate(167.71 19.926)" />
                    <path d="M127.008,165.857l-.006,0L0,82.927,127.008,0V165.857ZM117.043,18.4,18.224,82.927l98.819,64.527Z"
                      transform="translate(82.88 84.782)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 192.618)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 212.544)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 112.914)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 132.84)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 172.692)" />
                    <rect width="9.963" height="9.963" transform="translate(226.492 152.766)" />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <div class="video__button container column align-items-center color-white" v-if="!playing && !first">
            <img src="@/assets/img/icons/replay.svg" @click="replay()" class="image-btn">
            <span class="margin-top-10">REPLAY</span>
            <div class="video__button__alert margin-top-30 justify-content-center align-items-center">
              <img src="@/assets/img/icons/alert-video.svg">
              <span>Responda para continuar!</span>
            </div>
          </div>
        </div>
      </div>

      <div class="select-question__right flex-grow-2 flex-basis-500">
        <ul class="list-none relative">
          <li v-for="(q, ind) in exercise.questions" class="animation-bottom" :style="{animationDelay: (ind / 20) + 's'}" :key="ind">
            <div class="select-audio-question__item container align-items-center" :class="{disable : ((ind != index) && !q.answered)}">

              <div class="audio">
                <div class="translate--words__box--block-audio">
                  <button class="audio-play" @click="play(ind)" :disabled="playing || !played">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30"
                      height="30" viewBox="0 0 30 30">
                      <defs>
                        <clipPath id="b">
                          <rect width="30" height="30"></rect>
                        </clipPath>
                      </defs>
                      <g id="a" clip-path="url(#b)">
                        <g transform="translate(-363 -420)">
                          <path d="M7.5,2.017a14.994,14.994,0,0,1,21.98,16.866A15.012,15.012,0,0,1,15.024,30a15.09,15.09,0,0,1-3.905-.517A14.994,14.994,0,0,1,7.5,2.017ZM27.975,18.478a13.432,13.432,0,0,0-9.5-16.451,13.512,13.512,0,0,0-3.5-.463A13.437,13.437,0,0,0,3.367,21.718a13.432,13.432,0,0,0,24.607-3.24Z"
                            transform="translate(363 419.998)" fill="#6200e5"></path>
                          <path d="M51.729,33.388a13.418,13.418,0,1,1-11.655-6.721,13.514,13.514,0,0,1,3.5.463A13.346,13.346,0,0,1,51.729,33.388Zm-2.555.689a.781.781,0,0,0,.14-1.1,11.774,11.774,0,0,0-7.658-4.422.781.781,0,0,0-.212,1.547,10.2,10.2,0,0,1,6.635,3.83.781.781,0,0,0,1.1.14ZM48.107,40.1a1.616,1.616,0,0,0-.817-1.415l-9.64-5.566A1.634,1.634,0,0,0,35.2,34.539V45.67a1.632,1.632,0,0,0,2.451,1.415l9.64-5.566A1.616,1.616,0,0,0,48.107,40.1Z"
                            transform="translate(337.904 394.895)" fill="#9b8ccc"></path>
                          <g transform="translate(373.103 423.448)">
                            <path d="M276.024,63.283a.781.781,0,0,1-1.235.956,10.2,10.2,0,0,0-6.635-3.83.781.781,0,0,1,.212-1.547A11.774,11.774,0,0,1,276.024,63.283Z"
                              transform="translate(-261.91 -58.854)" fill="#6200e5"></path>
                            <path d="M184.511,138.867a1.634,1.634,0,0,1,0,2.829l-9.64,5.566a1.634,1.634,0,0,1-2.451-1.415V134.716a1.634,1.634,0,0,1,2.451-1.415Zm-.745,1.415a.063.063,0,0,0-.036-.062l-9.64-5.566a.075.075,0,0,0-.036-.011.076.076,0,0,0-.037.011.065.065,0,0,0-.037.063v11.131a.065.065,0,0,0,.037.063.068.068,0,0,0,.073,0l9.64-5.567A.063.063,0,0,0,183.766,140.282Z"
                              transform="translate(-172.419 -128.73)" fill="#6200e5"></path>
                          </g>
                          <path d="M208.816,165.325a.072.072,0,0,1,0,.125l-9.64,5.566a.068.068,0,0,1-.073,0,.065.065,0,0,1-.037-.063V159.822a.065.065,0,0,1,.037-.063.077.077,0,0,1,.037-.011.075.075,0,0,1,.036.011Z"
                            transform="translate(175.597 269.612)" fill="#ffb300"></path>
                        </g>
                      </g>
                    </svg>
                    <audio ref="audio" :src="q.audio"/>
                  </button>
                </div>
              </div>

              <div class="image">
                <img :src="q.img" width="100%">
              </div>
              <p class="word-center">
                {{ spliceIntoArray(q).first }}
                <span class="word_esp" style="display: block;" :class="{'word-correct' : checkCorrect(q), 'word-wrong' : checkWrong(q) }">
                  {{ q.answered?getSelected(q):``}}
                </span>
                {{ spliceIntoArray(q).last }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="">
      <div class="select-question__words watch-select-word">
        <div class="select-question__right flex-grow-1 flex-basis-1200">
          <ul class="list-none relative container wrap align-items-center justify-content-around relative">
            <li
              v-for="(aswr, ind) in question.answers"
              class="animation-bottom"
              :style="{animationDelay: (ind / 20) + 's'}"
              :key="ind"
              @click="selectQuestion(aswr)">
              <div class="select-word__item container align-items-center" :class="{
                       'word-correct': aswr.correct && question.answered,
                       'word-wrong' : aswr.selected && !aswr.correct && question.answered
                     }">
                {{aswr.text}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">

        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>

        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="correct && question.answered">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta
          </span>
        </div>
        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="!correct && question.answered">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta
          </span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

  <script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { mapGetters } from "vuex";

export default {
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  data() {
    return {
      selected: '',
      finish: false,
      showFeedback: false,
      clicks: 0,
      question: {
        answers: []
      },
      ended: false,
      playing: false,
      played: false,
      interruption: null,
      currentTime: 0,
      oldTime: 0,
      interrupted: false,
      first: true,
      showInfo: false,
      index: 0
    }
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise () {
      return this.subTopic.exercise
    }
  },
  methods: {
    async selectQuestion (answer) {
      let correct = false

      if (!this.question.answered && this.interrupted) {
        if (answer.correct) correct = true
        else correct = false
        answer.selected = true
        this.question.hit = correct
        this.question.answered = true
        this.selected = answer.text
        this.interrupted = false
        this.feedback()
        this.$refs['audio'][this.index].pause()
        await this.save(this.question)
      }
    },

    async feedback () {
      this.showFeedback = true
      if (this.showFeedback) {
        await this.$delay(1500)
        this.showFeedback = false
        gameBus.$emit('setEnabled', true)
      }
    },
    play (index) {
      if (index == this.index) {
        this.$refs['audio'].forEach(a => a.pause())
        this.$refs['audio'][index].play()
      }
    },
    playVideo () {
      if (this.first || this.ended) {
        this.$refs[`video`].pause()
        this.$refs[`video`].play()
      }
      this.first = false
    },
    replay () {
      if (this.index == 0) this.$refs['video'].currentTime = 0
      else this.$refs['video'].currentTime = this.exercise.questions[this.index - 1].time
      this.$refs['video'].play()
    },
    async setCurrent () {
      let qst          = {},
          currentIndex = 0
      const questions = this.exercise.questions.sort((a, b) => a.time - b.time)
      this.selected = ``
      for (const index in questions) {
        currentIndex = index
        if (!questions[index].answered) {
          qst = questions[index]
          this.interruption = parseFloat(qst.time)
          break;
        } else if (parseInt(index) === (questions.length - 1)) {
          qst = questions[index]
          this.ended = true
          this.interruption = null
        }
      }
      this.index = currentIndex
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
        if (!this.first) {
          this.$refs[`video`].pause()
          this.$refs[`video`].play()
        }
        if (this.ended) {
          const wordIndex = this.exercise.questions[this.index].answers.findIndex(x => x.selected)
          this.selected = this.question.answers[wordIndex].text
        }
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    timeUpdated (time) {
      if (this.oldTime === null) this.oldTime = time
      else this.oldTime = this.currentTime
      this.currentTime = time
      if (this.interruption >= 0 && this.interruption !== null) {
        if ((this.interruption >= this.oldTime) && (this.interruption <= this.currentTime)) {
          this.$refs['video'].pause()
        }
      }
    },
    checkCorrect (question) {
      const index = question.answers.findIndex(x => (x.selected && x.correct))
      if (question.answered && (index >= 0)) return true
      else return false
    },
    checkWrong (question) {
      const index = question.answers.findIndex(x => (x.selected && !x.correct))
      if (question.answered && (index >= 0)) return true
      else return false
    },
    spliceIntoArray (question) {
      const titleArray = question.text.split(` `)
      const correctIndex = question.answers.findIndex(x => x.correct)
      const correctWord = question.answers[correctIndex].text
      const wordIndex = titleArray.findIndex(x => x.toLowerCase() === correctWord.toLowerCase())

      let firstPart = titleArray.slice(0, wordIndex);
      let lastPart = titleArray.slice(wordIndex + 1, titleArray.length);

      firstPart = firstPart.join(` `)
      lastPart = lastPart.join(` `)
      return {
        first: firstPart,
        last: `${lastPart}.`
      }
    },
    getSelected (question) {
      const index = question.answers.findIndex(x => x.selected)
      return question.answers[index].text
    },
    async save (question) {
      let scoreQuestions = 0,
          answered       = 0

      for (const qst of this.exercise.questions) {
        for (const aswr of qst.answers) {
          if (aswr.selected && aswr.correct) scoreQuestions++
        }
        if (qst.answered) answered++
      }

      const score = (scoreQuestions * 100)/this.exercise.questions.length
      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      }

      if (answered == this.exercise.questions.length) {
        payload.finished = true
        this.ended = true
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit('updateProgress', score)

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch('subTopic/answerQuestion', payload)
    },
    closeModal () {
      this.showInfo = false
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    async viewQuestion (index) {
      if (this.ended && this.index != index) {
        const question = this.exercise.questions[index]
        if (question && question.answered) {
          this.index = index
          this.$set(this, 'question', question)
          this.$refs['video'].pause()
          this.$refs['video'].currentTime = question.time
          const wordIndex = this.exercise.questions[this.index].answers.findIndex(x => x.selected)
          this.selected = this.question.answers[wordIndex].text
        }
      }
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },

  async mounted () {
    this.setCurrent()
    gameBus.$emit('updateProgress', this.subTopic.points)
    modalBus.$on('close', this.closeModal)
    gameBus.$on('viewQuestion', this.viewQuestion)
    gameBus.$on('setCurrent', this.setCurrent)
  },
  beforeDestroy () {
    modalBus.$off('close', this.closeModal)
    gameBus.$off('viewQuestion', this.viewQuestion)
    gameBus.$off('setCurrent', this.setCurrent)
  }
}
</script>

<style lang="scss">
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/watchSelectWord";
@import "./src/assets/css/components/answerSelectQuestion";
@import "./src/assets/css/components/imageLoader";

.word-center {
  display: inherit;

  .word_esp {
    padding: 2.5px 0px 2.5px 0px !important;
  }
}

.video__button {
  top: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, .5);
  border-radius: 17.5px;
  border: none;
  & img.image-btn {
    align-self: center;
    transition: all .15s ease;
    border: 0px solid #ddd;
    border-radius: 150px;
    &:hover {
      transform: scale(1.1);
      cursor: pointer;
      border: 15px solid rgba(#ddd, .5);
    }
  }
  &__alert {
    display: flex;
    width: 265px;
    height: 55px;
    border-radius: 35px;
    background-color: $color-yellow;
    padding-right: 10px;
    img {
      height: 100%;
      margin-top: 11px;
      margin-right: 7px;
    }
  }
}

.watch-select-word {
  background: #ffedb1;
  border-radius: 10px;
  margin-top: 20px;

  .select-word__item {
    background: #ff9900;
    border: 1px solid #e26200;
  }
}

.translate--words__box--block-audio .audio-play {
  background: none;
  width: 30px;
  height: 30px;
}

// button.play {
//   cursor: pointer;
//
//   svg {
//     transition: 0.3s;
//   }
//
//   &:hover {
//     svg {
//       transform: scale(1.3, 1.3);
//     }
//   }
// }

.video_info {
  background: rgb(253, 217, 59);
  color: #c2003c;
  position: absolute;
  bottom: 40px;
  padding: 10px 20px;
  text-align: center;
  font-size: 12px;
  box-sizing: border-box;
  border-radius: 10px;
  max-width: 90%;
  margin: 0 auto;
  @media (max-width: 576px) {
    bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/watchSelectWord.vue